import React from "react";
import PropTypes from "prop-types";
import LiveTvIcon from "@mui/icons-material/LiveTv";
import ErrorScreen from "core/components/ErrorScreen";
import PlayerPreview from "core/components/PlayerPreview";
import { useTranslation } from "react-i18next";

export default function StreamOfflineScreen({ content }) {
  const { t } = useTranslation("core");

  return (
    <PlayerPreview preview={content.preview} overlay>
      <ErrorScreen
        icon={LiveTvIcon}
        title={t("streamIsOffline.title")}
        text={t("streamIsOffline.text")}
      />
    </PlayerPreview>
  );
}

StreamOfflineScreen.propTypes = {
  content: PropTypes.shape({
    preview: PropTypes.string,
    startAt: PropTypes.string,
  }).isRequired,
};
